import chromeExports from "./chrome";
import oprExports from "./opr";
export const chrome = chromeExports;
export const opr = oprExports;
